import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";

/** Page access is independent of sidebar visibility. Backend APIs still enforce ordinary data-read authorization. */
export function isConfigPageAccessible(page: unknown, userTemplateId: Uuid): boolean {
    if (typeof page !== "object" || page === null) {
        return false;
    }
    if (!("allowedUserTemplateIds" in page) || page.allowedUserTemplateIds === undefined) {
        return true;
    }
    const allowedIds: unknown = page.allowedUserTemplateIds;
    return Array.isArray(allowedIds)
        && allowedIds.every((id: unknown) => typeof id === "string")
        && allowedIds.includes(userTemplateId);
}
